import React from 'react';
import { Logger } from '../utils';
import Video from 'twilio-video';

class Preflight extends React.Component {
    constructor(props) {
        super(props);
        this.testRef = React.createRef();
        this.state = { testRunning: false };
        this.preflightTest = null;
    }

    componentDidUpdate(prevProps) {
        const { preflightTokenInfo } = this.props;
        if (!preflightTokenInfo) return;
        const { token = "" } = preflightTokenInfo || {};
        if (token && !this.testStarted) {
            this.testStarted = true;
            this.startPreflightTest();
        }
    }

    componentWillUnmount() {
        this.cleanup();
    }

    cleanup = () => {
        if (this.preflightTest) {
            this.preflightTest.stop();
            this.preflightTest.removeAllListeners('completed');
            this.preflightTest.removeAllListeners('failed');
            this.preflightTest = null;
        }
    }

    startPreflightTest = () => {
        const { testRunning } = this.state;
        const { preflightTokenInfo, callbackOnComplete } = this.props;
        const { token = "", roomName = "", testDuration, twilioUserName = "" } = preflightTokenInfo || {};
        if (!token || testRunning || !Video.runPreflight)
            return;
        this.setState({ testRunning: true }, () => {           
            Logger("UI.Twilio.Room.PreflightTest.Started", new Date());
            this.preflightTest = Video.runPreflight(token, { duration: testDuration * 1000 });
            if (this.preflightTest) {
                this.preflightTest.on('completed', (report) => {
                    console.log({ report });                    
                    Logger("UI.Twilio.Room.PreflightTest.Completed", new Date(), { roomId: roomName, twilioUserName, report: report } );
                    this.setState({ testRunning: false });
                    if (callbackOnComplete)
                        callbackOnComplete();
                })
                this.preflightTest.on('failed', (error) => {
                    console.log({ error });
                    Logger("UI.Twilio.Room.PreflightTest.Failure", new Date(), { roomId: roomName, twilioUserName, error : error.message ? error.message : error});
                    this.setState({ testRunning: false });
                    if (callbackOnComplete)
                        callbackOnComplete();
                });
            }
        });


    }

    render() {
        return null;
    }
}

export default Preflight;
